module.exports = __webpack_public_path__ + "img/serviceGuide-center-4.fad2c2b.png";